var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isModalOpen)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('button',{staticClass:"btn btn-blue-outline",on:{"click":_vm.closeModal}},[_vm._v(_vm._s(_vm.$t('닫기')))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }